import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Standing-rule UX pattern: a small help icon next to a term/section that opens a short plain-English tip.
export const HelpTip = ({ text, testid }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" aria-label="Help" className="inline-flex align-middle text-muted-foreground hover:text-foreground ml-1" data-testid={testid || "help-tip"}>
        <HelpCircle className="h-3.5 w-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent side="top" className="w-64 text-sm rounded-none leading-snug">{text}</PopoverContent>
  </Popover>
);
